// Import dependencies
import React, {Component} from 'react';
import { TweenMax } from "gsap/TweenMax";
import history from '../components/router/history';

// Import components
import { TitleText, ParagraphText } from "../components/global/UXLibrary";
import MainButton from "../components/global/buttons/MainButton";

// Import css
import './RequestBrochure.css';

// Import images
import logo from '../resources/icons/logo.svg'
import Grid from "../components/global/Grid";
import ReactHowler from "react-howler";
import click from "../resources/sounds/click.mp3";
import focus from "../resources/sounds/focus.mp3";

const charming = require('charming')

export default class RequestBrochure extends Component {
    constructor(props)
    {
        super(props);
        this.state = {
            width: 0,
            focusPlaying: false,
            clickPlaying: false,
            sent: false
        };
        this.grid = React.createRef();
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.playFocus = this.playFocus.bind(this);
        this.stopFocus = this.stopFocus.bind(this);
        this.playClick = this.playClick.bind(this);
        this.submitRequest = this.submitRequest.bind(this);
    }

    instantiateNearby()
    {
        /**
         * nearby.js
         * http://www.codrops.com
         *
         * Licensed under the MIT license.
         * http://www.opensource.org/licenses/mit-license.php
         *
         * Copyright 2018, Codrops
         * http://www.codrops.com
         */
        {
            /**
             * Distance between two points P1 (x1,y1) and P2 (x2,y2).
             */
            const distancePoints = (x1, y1, x2, y2) => Math.sqrt((x1-x2)*(x1-x2)+(y1-y2)*(y1-y2));

            // from http://www.quirksmode.org/js/events_properties.html#position
            const getMousePos = (e) => {
                var posx = 0, posy = 0;
                if (!e) var e = window.event;
                if (e.pageX || e.pageY) 	{
                    posx = e.pageX;
                    posy = e.pageY;
                }
                else if (e.clientX || e.clientY) 	{
                    posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
                    posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
                }
                return { x : posx, y : posy }
            };

            class Nearby {
                constructor(el, options) {
                    this.DOM = {el: el};
                    this.options = options;
                    this.init();
                }
                init() {
                    this.mousemoveFn = (ev) => requestAnimationFrame(() => {
                        const mousepos = getMousePos(ev);
                        const docScrolls = {left : document.body.scrollLeft + document.documentElement.scrollLeft, top : document.body.scrollTop + document.documentElement.scrollTop};
                        const elRect = this.DOM.el.getBoundingClientRect();
                        const elCoords = {
                            x1: elRect.left + docScrolls.left, x2: elRect.width + elRect.left + docScrolls.left,
                            y1: elRect.top + docScrolls.top, y2: elRect.height + elRect.top + docScrolls.top
                        };
                        const closestPoint = {x: mousepos.x, y: mousepos.y};

                        if ( mousepos.x < elCoords.x1 ) {
                            closestPoint.x = elCoords.x1;
                        }
                        else if ( mousepos.x > elCoords.x2 ) {
                            closestPoint.x = elCoords.x2;
                        }
                        if ( mousepos.y < elCoords.y1 ) {
                            closestPoint.y = elCoords.y1;
                        }
                        else if ( mousepos.y > elCoords.y2 ) {
                            closestPoint.y = elCoords.y2;
                        }
                        if ( this.options.onProgress ) {
                            this.options.onProgress(distancePoints(mousepos.x, mousepos.y, closestPoint.x, closestPoint.y))
                        }
                    });

                    window.addEventListener('mousemove', this.mousemoveFn);
                }
            }

            window.Nearby = Nearby;
        }
    }

    launchAnimation()
    {
        const lineEq = (y2, y1, x2, x1, currentVal) => {
            // y = mx + b
            var m = (y2 - y1) / (x2 - x1), b = y1 - m * x1;
            return m * currentVal + b;
        };
        const shuffleArray = arr => arr.sort(() => Math.random() - 0.5);

        const formItems = Array.from(document.querySelectorAll('.form__item'));
        formItems.forEach((item) => {
            const inputEl = item.querySelector('.form__input');
            if ( inputEl ) {
                const label = item.querySelector('.form__label');
                const placeholder = item.querySelector('.form__placeholder');
                charming(label);
                const labelLetters = Array.from(label.querySelectorAll('span'));

                charming(placeholder);
                const placeholderLetters = Array.from(placeholder.querySelectorAll('span'));
                const lettersTotal = placeholderLetters.length;
                const lettersPosArr = shuffleArray(Array.from(Array(lettersTotal).keys()));
                let currentVisible = lettersTotal;

                // whatever we do, start at [distanceThreshold.max]px from the element and end at [distanceThreshold.min]px from the element.
                const distanceThreshold = {min: 0, max: 50};

                new window.Nearby(inputEl, {
                    onProgress: (distance) => {
                        const point = lineEq(lettersTotal, 0, distanceThreshold.max, distanceThreshold.min, distance);
                        const visible = Math.max(0,Math.min(lettersTotal,Math.floor(point)));
                        if ( currentVisible != visible ) {
                            // hide placeholder and show label.
                            if ( visible < currentVisible ) {
                                for (let i = 0, len = lettersPosArr.length - visible; i < len; ++i) {
                                    const letter = placeholderLetters[lettersPosArr[i]];
                                    if ( letter.dataset.state != 'hidden' ) {
                                        letter.dataset.state = 'hidden';
                                        TweenMax.to(letter, 0.5, {
                                            //ease: 'Back.easeIn',
                                            ease: 'Expo.easeOut',
                                            y: '-200%',
                                            opacity: 0
                                        });

                                        TweenMax.to(labelLetters[lettersPosArr[i]], 0.5, {
                                            //ease: 'Back.easeOut',
                                            //delay: 0.4,
                                            ease: 'Expo.easeOut',
                                            y: '0%',
                                            startAt: {y: '200%'},
                                            opacity: 1
                                        });
                                    }
                                }
                            }
                            // hide label and show placeholder. (only if input doesn't have a value).
                            else if (inputEl.value.length === 0) {
                                for (let i = lettersTotal-1, len = lettersTotal- (lettersPosArr.length - visible); i >= lettersTotal-len; --i) {
                                    const letter = placeholderLetters[lettersPosArr[i]];
                                    if ( letter.dataset.state === 'hidden' ) {
                                        letter.dataset.state = '';
                                        TweenMax.to(letter, 0.2, {
                                            ease: 'Circ.easeOut',
                                            y: '0%',
                                            //overwrite: 'all',
                                            opacity: 1
                                        });

                                        TweenMax.to(labelLetters[lettersPosArr[i]], 1, {
                                            ease: 'Circ.easeOut',
                                            y: '200%',
                                            //overwrite: 'all',
                                            opacity: 0
                                        });
                                    }
                                }
                            }

                            if( visible <= 0 ) {
                                inputEl.focus();
                            }

                            currentVisible = visible;

                        }
                    }
                });

                inputEl.addEventListener('input', () => {
                    if ( inputEl.value.length !== 0 ) {
                        placeholder.style.opacity = 0;
                    }
                    else {
                        placeholder.style.opacity = 1;
                    }
                });
            }
        });
    }

    // Focuses elements with a grid
    focusElement = (event) =>
    {
        // Get bounding rectangle of the button
        let location = event.target.getBoundingClientRect();
        // Update grid
        this.grid.current.focus(location.top, location.bottom, location.left, location.right);
    };
    // Resets grid focus
    resetFocus = () =>
    {
        this.grid.current.updateDimensions();
    };

    // Updates window dimensions on window resize event
    updateWindowDimensions()
    {
        this.setState({ width: window.innerWidth });
    }

    submitRequest()
    {
        this.setState({ sent: true });

        setTimeout(function() {
            history.push('/services');
        }, 3000);
    }

    // Methods for playing and stopping sounds
    playFocus()
    {
        this.setState({ focusPlaying: true });
    }
    stopFocus()
    {
        this.setState({ focusPlaying: false });
    }
    playClick()
    {
        this.setState({ clickPlaying: true });

        setTimeout(function() { this.setState({ clickPlaying: false }) }.bind(this), 100);

    }

    componentDidMount() {
        this.instantiateNearby();
        this.launchAnimation();
    }

    componentWillMount()
    {
        // Set window resize listener
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount()
    {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    render() {
        const { service } = this.props.location.state;

        return (
            <div className='services__container'>
                {
                    this.state.sent ?
                        <div className='rb__success-title'>
                            <TitleText>
                                Thank you!
                            </TitleText>
                            <div style={{ marginTop: 10 }}>
                                <ParagraphText>
                                    A member of our team will be in touch shortly.<br/>
                                    You will be redirected soon.
                                </ParagraphText>
                            </div>
                        </div>
                        :
                        <div>
                            {/* The Form */}
                            <div className='rb__form'>
                                <div className='rb__title-container'>
                                    <TitleText>
                                        Request Our<br/>
                                        { service } Brochure
                                    </TitleText>
                                </div>

                                <div className="form__item">
                                    <label className="form__label" htmlFor="firstname">Full Name</label>
                                    <input className="form__input" type="text" name="firstname" id="firstname" />
                                    <span className="form__placeholder">Full Name</span>
                                </div>

                                <div className="form__item" style={ this.state.width > 900 ? { marginRight: '4%' } : null }>
                                    <label className="form__label" htmlFor="firstname">Email</label>
                                    <input className="form__input" type="text" name="firstname" id="firstname" />
                                    <span className="form__placeholder">Email</span>
                                </div>

                                <div
                                    style={{display: 'inline-block', pointerEvents: 'all', marginTop: '4%'}}
                                    onMouseEnter={(event) => {
                                        if (this.state.width > 770) {
                                            this.focusElement(event);
                                            this.playFocus();
                                        }
                                    }}
                                    onMouseLeave={() => {
                                        if (this.state.width > 770) {
                                            this.resetFocus();
                                            this.stopFocus();
                                        }
                                    }}
                                    onClick={() => {
                                        this.playClick();
                                        this.submitRequest()
                                    }}
                                >
                                    <MainButton title='request' />
                                </div>
                            </div>
                        </div>
                }

                {/* Bottom Bar */}
                <div className='services__bottom-bar'>
                    <div className='services__tag-line'>
                        <img src={logo} className='services__bottom-logo' alt='rootnote-logo' />
                    </div>
                    <div className='services__menu'>

                    </div>
                </div>

                {/* Grid */}
                <Grid ref={this.grid} />

                {/* Sound Component */}
                {
                    this.state.focusPlaying && this.props.sound ?
                        <ReactHowler
                            src={ focus }
                            playing={ true }
                            preload={ true }
                            ref={(ref) => (this.focus = ref)}
                            autoUnlock={ true }
                            autoSuspend={ false }
                        />
                        :
                        null
                }
                {
                    this.state.clickPlaying && this.props.sound ?
                        <ReactHowler
                            src={ click }
                            playing={ true }
                            preload={ true }
                            ref={(ref) => (this.click = ref)}
                            autoUnlock={ true }
                            autoSuspend={ false }
                        />
                        :
                        null
                }
            </div>
        );
    }
}
